(function () {
    'use strict';

    angular.module('app.shared.services').factory('commonInformationService', ['$http', '$q', 'httpRequest', 'appGlobals',
        function ($http, $q, httpRequest, appGlobals) {

            var menuItems = null;
            var baseUrl = appGlobals.baseApiUrl;

            var clearCache = function () {
                menuItems = null;
            };

            var getMenuItems = function (successCallback, errorCallback, allowCache) {
                if (allowCache == null) allowCache = true;
                if (menuItems == null || !allowCache) {
                    GetCIMenuItems().then(successCallback, errorCallback);
                } else {
                    successCallback(menuItems);
                }
            };
            var GetCIMenuItems = function () {
                console.log("Inside GetCIMenuItems");
                var url = baseUrl + "MenuItems";
                console.log(url);
				return httpRequest.doGetRequest(url);
            };

            //var getMenuByGroupKey = function (key, successCallback, errorCallback) {
            //    console.log("Inside getMenuByGroupKey");
            //    var url = baseUrl + "MenuGroup/" + key + "/MenuItems";
            //    console.log(url);
            //    httpRequest.doGetRequest(url, null, successCallback, errorCallback);
            //};

            // Bill's code

			var defaultMenuGroupKey = appGlobals.defaultMenuGroupKey;
            var currMenuGroupKey = defaultMenuGroupKey;
            var menuCallbacks = [];

            var getCurrentMenu = function () {
				return $q(function (resolve, reject) {
					//Dominick Moved this here so I can update within the same module
					var defaultMenuGroupKey = appGlobals.defaultMenuGroupKey;
					currMenuGroupKey = defaultMenuGroupKey;
					currMenuGroupKey = currMenuGroupKey || defaultMenuGroupKey;
					if (currMenuGroupKey == null) reject("currMenuGroupKey not defined");

					var groupKey = (currMenuGroupKey == null) ? 2 : currMenuGroupKey;
					var url = baseUrl + "MenuGroup/" + groupKey + "/MenuItems";
					httpRequest.doGetRequest(url).then(function (data) { resolve(data); }, function (response) { reject(response); });
				});
            };

            var registerMenuCallback = function (callback) {
                menuCallbacks.push(callback);
            };

            var changeMenuGroup = function (groupKey) {
                currMenuGroupKey = groupKey;
                notifyObservers();
            };

            var notifyObservers = function () {
                angular.forEach(menuCallbacks, function (callback) {
                    callback();
                });
            };
            // end

            return {
                clearCache: clearCache,
                getMenuItems: getMenuItems,

                //getMenuByGroupKey: getMenuByGroupKey,
                getCurrentMenu: getCurrentMenu,
                registerMenuCallback: registerMenuCallback,
                changeMenuGroup: changeMenuGroup,
                getCurrMenuGroupKey: function () { return currMenuGroupKey; }
            };

        }
    ]);

    angular.module('app.shared.services').factory('focus', ['$timeout',
        function ($timeout) {
            return function (id) {
                // timeout makes sure that it is invoked after any other event has been triggered.
                $timeout(function () {
                    var element = document.getElementById(id);
                    if (element)
                        element.focus();
                });
            };
        }
    ]);

})();